import { ctxReport } from '@/contexts/ReportCtx';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export default function AddresseeInput() {
  const { t } = useTranslation();
  const reportCtx = useContext(ctxReport);

  return (
    <input
      id="report-addressee-input"
      type="text"
      value={reportCtx?.addressee}
      onChange={(e) => reportCtx?.setAddressee(e.target.value)}
      placeholder={t('report.giveEmail')}
    />
  );
}
